import { styled } from 'goober';
import { BREAKPOINTS } from '@shared/config/breakpoints/breakpoints';

export const Wrapper = styled('section')`
    display: grid;
    grid-template-columns: repeat(3, 31.6%);
    grid-auto-rows: auto;
    grid-gap: 12px;

    @media screen and (min-width: ${BREAKPOINTS.DESKTOP_S}px) {
        grid-template-columns: repeat(6, 15.1%);
    }

    @media screen and (min-width: ${BREAKPOINTS.DESKTOP_M}px) {
        grid-template-columns: repeat(6, 15.6%);
    }
`;
